import { IPerformaI18n } from './IPerformaI18n';
import { useService } from '../ioc/hook/useService';
import { QuinoCoreServiceSymbols } from '@quino/core';

export const useI18n = (): IPerformaI18n =>
    useService<IPerformaI18n>(QuinoCoreServiceSymbols.II18N);
